import { Link } from "gatsby"
import React from "react"
import config from "../lib/config"
import features from "../lib/homepage-features-list"

export default function Features() {
  return (
    <>
      <div
        className="bg-gradient-to-r from-default-600 to-default-700"
        id="features"
      >
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-16 sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="text-3xl font-extrabold text-white tracking-tight">
            {config.siteTitle} offers the emergency response features schools
            need
          </h2>
          <p className="mt-4 max-w-3xl text-lg text-default-200">
            {config.siteTitle} is a platform created for schools, with unique
            features that help make the emergency response process in schools
            safer, more efficient and more effective.
          </p>
          <div className="mt-8 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:mt-10 lg:grid-cols-4 lg:gap-x-4">
            {features.map(feature => (
              <div
                key={feature.name}
                className="bg-white bg-opacity-10 rounded-md p-4"
              >
                <div>
                  <span className="flex items-center justify-center h-16 w-full">
                    <feature.icon
                      className="h-10 w-10 text-white"
                      aria-hidden="true"
                    />
                  </span>
                  <h3 className="text-lg font-medium text-white text-center">
                    {feature.name}
                  </h3>
                </div>
                <div className="mt-3">
                  <p className="text-base text-default-200 opacity-90">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-white pt-12 sm:pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              It's incredibly reliable, fast, and easy to set up
            </h2>
            <p className="mt-3 text-xl text-gray-500 sm:mt-4">
              {config.siteTitle} is blazing fast, quick to set up for your
              school, and so much more.
            </p>
          </div>
        </div>
        <div className="mt-10 pb-12 bg-white sm:pb-16">
          <div className="relative">
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-4xl mx-auto">
                <dl className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3">
                  <div className="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r">
                    <dt className="order-2 mt-3 text-lg leading-7 font-medium text-gray-500">
                      average uptime of {config.siteTitle}
                    </dt>
                    <dd className="order-1 text-5xl font-extrabold text-default-600">
                      99.99%
                    </dd>
                  </div>

                  <div className="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r">
                    <dt className="order-2 mt-3 text-lg leading-7 font-medium text-gray-500">
                      messages {config.siteTitle} can send per second
                    </dt>
                    <dd className="order-1 text-5xl font-extrabold text-default-600">
                      1,500+
                    </dd>
                  </div>
                  <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
                    <dt className="order-2 mt-3 text-lg leading-7 font-medium text-gray-500">
                      expected time to set up {config.siteTitle} at your school
                    </dt>
                    <dd className="order-1 text-5xl font-extrabold text-default-600">
                      45 min
                    </dd>
                  </div>
                </dl>
              </div>
              <div className="mt-12 flex justify-center">
                <Link
                  to="/request-a-demo"
                  className="transition-all flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-default-600 hover:bg-default-700 md:py-4 md:text-lg md:px-10"
                >
                  Request a Demo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
